// src/constants/defaultSettings.ts

import { ICallScreenSettings } from "src/types/models/apiModels";

export const defaultScreenSetting: ICallScreenSettings = {
    answerCallButton: {
        color: {
            background: "#116903",
            foreground: "#FFFFFF",
        },
    },
    appLogo: {
        size: {
            height: 150,
            width: 150,
        },
    },
    background: {
        color: "#0A0A0A",
    },
    endCallButton: {
        color: {
            foreground: "#FFFFFF",
            background: "#FF0000",
        },
    },
    otherButton: {
        color: {
            background: "#FFFFFF",
            foreground: "#000000",
        },
    },
};

// Add other constants or default settings here